// import React from "react";
// import UserPageHeader from '../components/UserPageHeader';

// const ContactPage = () => {
//   return (
//     <div className="min-h-screen bg-gradient-to-b from-white to-[#e6f4f1] text-gray-800 flex flex-col items-center">
     
//    <UserPageHeader />
//       {/* Header */}
//       <div className="text-center mt-10 px-4 mt-20">
//         <h1 className="text-3xl font-bold mb-4">Get In Touch</h1>
//         <p className="max-w-xl mx-auto text-gray-600">
//         We'll provide reliable, well-maintained vehicles and build lasting customer trust with each rental, paving the way for you to travel comfortably
//         </p>
//       </div>

//       {/* Contact Section */}
//       <div className="mt-10 flex flex-col lg:flex-row bg-white shadow-2xl rounded-xl max-w-5xl w-full p-6 gap-6 mx-4">
//         {/* Left: Contact Info */}
//         <div className="bg-blue-600 text-white rounded-xl p-6 flex flex-col justify-between lg:w-1/2">
//           <div>
//             <h3 className="text-xl font-semibold mb-2">Contact Information</h3>
//             <p className="text-sm mb-6">
//              We offer high-quality vehicles and ensure dependable service across at least 40 major travel routes and locations.
//             </p>
//             <div className="mb-4">
//               <p className="font-semibold mb-1">📞 Phone</p>
//               <p className="text-sm">+0712345678</p>
//               <p className="text-sm">+0712345678</p>
//             </div>
//             <div className="mb-4">
//               <p className="font-semibold mb-1">📧 Email</p>
//               <p className="text-sm">Support@rental.com</p>
//             </div>
//             <div className="mb-2">
//               <p className="font-semibold mb-1">📍 Location</p>
//               <p className="text-sm">Colombo, Sri Lanka</p>
//             </div>
//           </div>

//           {/* Decorative bottom circle (optional for UI design) */}
//           <div className="mt-6">
//             <div className="w-24 h-24 bg-white opacity-20 rounded-full mx-auto lg:mx-0"></div>
//           </div>
//         </div>

//         {/* Right: Contact Form */}
//         <div className="flex-1">
//           <form className="space-y-6">
//             <div className="flex gap-4">
//               <div className="flex-1">
//                 <label className="block text-sm mb-1">Your Name</label>
//                 <input
//                   type="text"
//                   placeholder="John Trangely"
//                   className="w-full border-b border-gray-300 focus:outline-none focus:border-[#00bfa6] py-2"
//                 />
//               </div>
//               <div className="flex-1">
//                 <label className="block text-sm mb-1">Your Email</label>
//                 <input
//                   type="email"
//                   placeholder="hello@nurency.com"
//                   className="w-full border-b border-gray-300 focus:outline-none focus:border-[#00bfa6] py-2"
//                 />
//               </div>
//             </div>

//             <div>
//               <label className="block text-sm mb-1">Your Subject</label>
//               <input
//                 type="text"
//                 placeholder="I want to hire you quickly"
//                 className="w-full border-b border-gray-300 focus:outline-none focus:border-[#00bfa6] py-2"
//               />
//             </div>

//             <div>
//               <label className="block text-sm mb-1">Message</label>
//               <textarea
//                 rows="4"
//                 placeholder="Write here your message"
//                 className="w-full border-b border-gray-300 focus:outline-none focus:border-[#00bfa6] py-2"
//               ></textarea>
//             </div>

//             <button
//               type="submit"
//               className="bg-[#00bfa6] text-white px-5 py-2 rounded-md hover:bg-[#00a895]"
//             >
//               Send Message
//             </button>
//           </form>
//         </div>
//       </div>

//       {/* Footer */}
//       <footer className="mt-16 text-center text-sm text-gray-500 space-x-4">
//         <span>Terms</span>
//         <span>Privacy</span>
//         <span>Cookies</span>
//       </footer>
//     </div>
//   );
// };

// export default ContactPage;


import React, { useState } from "react";
import emailjs from 'emailjs-com';
import Header from '../components/Header';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const serviceID = 'service_v6rljze';     // Replace with your actual service ID
    const templateID = 'template_iipj1hd';   // Replace with your actual template ID
    const userID = '7t6ZwyKP7geniFJn0';      // Replace with your actual user ID (public key)

    emailjs.send(serviceID, templateID, formData, userID)
      .then((response) => {
        alert('Message sent successfully!');
        setFormData({ name: '', email: '', subject: '', message: '' });
      })
      .catch((error) => {
        console.error(error);
        alert('Failed to send message. Please try again later.');
      });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-[#e6f4f1] text-gray-800 flex flex-col items-center">
      <Header />

      {/* Header */}
      <div className="text-center mt-20 px-4">
        <h1 className="text-3xl font-bold mb-4">Get In Touch</h1>
        <p className="max-w-xl mx-auto text-gray-600">
          We'll provide reliable, well-maintained vehicles and build lasting customer trust with each rental, paving the way for you to travel comfortably.
        </p>
      </div>

      {/* Contact Section */}
      <div className="mt-10 flex flex-col lg:flex-row bg-white shadow-2xl rounded-xl max-w-5xl w-full p-6 gap-6 mx-4">
        {/* Contact Info */}
        <div className="bg-blue-600 text-white rounded-xl p-6 flex flex-col justify-between lg:w-1/2">
          <div>
            <h3 className="text-xl font-semibold mb-2">Contact Information</h3>
            <p className="text-sm mb-6">
              We offer high-quality vehicles and ensure dependable service across at least 40 major travel routes and locations.
            </p>
            <div className="mb-4">
              <p className="font-semibold mb-1">📞 Phone</p>
              <p className="text-sm">+0712345678</p>
              <p className="text-sm">+0712345678</p>
            </div>
            <div className="mb-4">
              <p className="font-semibold mb-1">📧 Email</p>
              <p className="text-sm">Support@rental.com</p>
            </div>
            <div className="mb-2">
              <p className="font-semibold mb-1">📍 Location</p>
              <p className="text-sm">Colombo, Sri Lanka</p>
            </div>
          </div>
          <div className="mt-6">
            <div className="w-24 h-24 bg-white opacity-20 rounded-full mx-auto lg:mx-0"></div>
          </div>
        </div>

        {/* Contact Form */}
        <div className="flex-1">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="flex gap-4">
              <div className="flex-1">
                <label className="block text-sm mb-1">Your Name</label>
                <input
                  type="text"
                  name="name"
                  placeholder="John Trangely"
                  className="w-full border-b border-gray-300 focus:outline-none focus:border-[#00bfa6] py-2"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="flex-1">
                <label className="block text-sm mb-1">Your Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="hello@nurency.com"
                  className="w-full border-b border-gray-300 focus:outline-none focus:border-[#00bfa6] py-2"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-sm mb-1">Your Subject</label>
              <input
                type="text"
                name="subject"
                placeholder="I want to hire you quickly"
                className="w-full border-b border-gray-300 focus:outline-none focus:border-[#00bfa6] py-2"
                value={formData.subject}
                onChange={handleChange}
              />
            </div>

            <div>
              <label className="block text-sm mb-1">Message</label>
              <textarea
                name="message"
                rows="4"
                placeholder="Write here your message"
                className="w-full border-b border-gray-300 focus:outline-none focus:border-[#00bfa6] py-2"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <button
              type="submit"
              className="bg-blue-600 text-white px-5 py-2 rounded-md hover:bg-[#00a895]"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>

      {/* Footer */}
      <footer className="mt-16 text-center text-sm text-gray-500 space-x-4">
        <span>Terms</span>
        <span>Privacy</span>
        <span>Cookies</span>
      </footer>
    </div>
  );
};

export default ContactPage;

